import { render, staticRenderFns } from "./PromoRequirePayment.vue?vue&type=template&id=06f32976&"
import script from "./PromoRequirePayment.vue?vue&type=script&lang=js&"
export * from "./PromoRequirePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f32976')) {
      api.createRecord('06f32976', component.options)
    } else {
      api.reload('06f32976', component.options)
    }
    module.hot.accept("./PromoRequirePayment.vue?vue&type=template&id=06f32976&", function () {
      api.rerender('06f32976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Promo/view/PromoRequirePayment.vue"
export default component.exports